import { PaletteColorOptions, PaletteOptions } from '@material-ui/core/styles/createPalette';

const primary: PaletteColorOptions = {
  light: '#30009C',
  main: '#30009C',
  dark: '#30009C',
  contrastText: '#fafafa',
};

const secondary: PaletteColorOptions = {
  light: '#E6E1F1',
  main: '#E6E1F1',
  dark: '#E6E1F1',
  contrastText: '#fff',
};

const palette: PaletteOptions = {
  primary,
  secondary,
  text: {
    secondary: '#7F8FA4'
  },
  action: {
    selected: '#E6E1F1',
  }
};

export default palette;
